import { jsx as _jsx } from "react/jsx-runtime";
import { SourceSuggestions } from '#pplx/frontend/composer-sdk-plugins/source-suggestion/SourceSuggestions.js';
export function SourceSuggestionsSlot({ sourceSuggestionsProps, }) {
    if (sourceSuggestionsProps === null || sourceSuggestionsProps === undefined) {
        return null;
    }
    return _jsx(SourceSuggestions, { ...sourceSuggestionsProps });
}
//# sourceMappingURL=SourceSuggestionsSlot.js.map